import { SET_INFO } from '../mutation-types';
import {
  setToken,
  removeToken,
} from '@/utils/auth';
import {
  userLogin,
  userLogout,
  updateAdminAccount,
} from '@/api/user';

const state = {
  info: {},
};

const mutations = {
  [SET_INFO]: (state, info) => {
    state.info = info;
  },
};

const actions = {
  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { username, password } = payload;
      userLogin(username, password.trim())
        .then((res) => {
          const { id } = res.data;
          setToken(id);
          commit(SET_INFO, res.data);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout() {
    return new Promise((resolve, reject) => {
      userLogout()
        .then(() => {
          removeToken();
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  modifyPassword(_, password) {
    return new Promise((resolve, reject) => {
      updateAdminAccount(password)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
